(function() {
    'use strict';

    angular.module('app')
        .constant('isTestMode', false)
        .constant('iAmNotRobot', true)
        .constant('apiUrl', {
            tsApi: '//hr.tsholdings.com.tw/api/',
            ssoApi: '//hr.tsholdings.com.tw/sso/api/',
            ctmsApi: '//hr.tsholdings.com.tw/ap/ctms/',
            pafUrl:'//hr.tsholdings.com.tw/hrapp/TSDG_PDF_Web/?pdf='
        });
})();